import delegate from "es6-delegate";
import LazyLoad from "../common/LazyLoad";

export default class Paging {
  constructor(options) {
    const defaultOptions = {
      categoryPageCount: 1,
      categoryDisplayPerPage: 30,
    };

    this.options = { ...defaultOptions, ...options };

    const pagingContainer = document.querySelector("#paging");
    if (pagingContainer) {
      this.options.categoryPageCount = pagingContainer.dataset.totalPages;
      this.options.categoryDisplayPerPage =
        pagingContainer.dataset.resultsPerPage;
    }

    if (this.options.categoryPageCount > 1) {
      this.rebuildPaging(
        1,
        this.options.categoryPageCount,
        this.options.categoryDisplayPerPage,
      );
    }
  }

  changeCategoryPage = (pageNumber) => {
    if (
      document.querySelector(
        `.category-page[data-category-page-number='${pageNumber}']`,
      )
    ) {
      document.querySelectorAll(".category-page").forEach((page) => {
        const el = page;
        el.style.display = "none";
      });
      document.querySelector(
        `.category-page[data-category-page-number='${pageNumber}']`,
      ).style.display = "block";
    }
  };

  getBackArrow = (currentPage) => {
    const isFirstPage = currentPage === 1;
    const pageNumber = isFirstPage ? "" : currentPage - 1;
    const disabledClass = isFirstPage ? "disabled" : "";
    const buttonHtml = isFirstPage
      ? '<span><i class="icon-left-open"></i></span>'
      : '<a href="javascript:void(0);"><i class="icon-left-open"></i></a>';
    const html = `
      <li class="${disabledClass} paging-button paging-button-previous" data-page-number="${pageNumber}">
        ${buttonHtml}
      </li>`;

    return html;
  };

  getForwardArrow = (currentPage, pageCount) => {
    let html = "";
    if (currentPage < pageCount) {
      html = `
        <li class="paging-button paging-button-next" data-page-number="${
          currentPage + 1
        }">
          <a href="javascript:void(0);"><i class="icon-right-open"></i></a>
        </li>`;
    } else {
      html = `
        <li class="disabled paging-button paging-button-next" data-page-number="">
          <span><i class="icon-right-open"></i></span>
        </li>`;
    }

    return html;
  };

  getPageButton = (page, isActive) => {
    const activeClass = isActive ? "active" : "";
    const buttonHtml = isActive
      ? `<span>${page}</span>`
      : `<a href="javascript:void(0);">${page}</a>`;
    const html = `
      <li class="${activeClass} paging-button paging-button-number" data-page-number="${page}">
        ${buttonHtml}
      </li>`;
    return html;
  };

  getEllipsis = () => '<li class="ellipsis"><span>&hellip;</span></li>';

  rebuildPaging = (currentPage, pageCount) => {
    const html = this.buildPagingHtml(currentPage, pageCount);

    document
      .querySelector(".pagination--unified")
      .querySelector("ul").innerHTML = html;

    LazyLoad.getInvisible().revalidate();

    delegate(
      "click",
      document.querySelectorAll(".paging-button"),
      this.handleButtonClick,
    );
  };

  buildPagingHtml = (currentPage, pageCount) => {
    let firstEllipsis = false;
    let lastEllipsis = false;
    let currentPageOffset = 2; // the range of number links shown before and after the current page
    let html = "";

    if (currentPage === 1 || currentPage === pageCount) {
      currentPageOffset += 1;
    }

    html += this.getBackArrow(currentPage);

    for (let page = 1; page <= pageCount; page += 1) {
      const showActivePageButton = page === currentPage;
      const showNonActivePageButton =
        (page < currentPage && page > currentPage - (currentPageOffset + 1)) ||
        (page > currentPage && page < currentPage + currentPageOffset + 1);

      if (showActivePageButton) {
        html += this.getPageButton(page, true);
      } else if (showNonActivePageButton) {
        html += this.getPageButton(page, false);
      } else if (
        !firstEllipsis &&
        page > 1 &&
        page < currentPage - currentPageOffset
      ) {
        firstEllipsis = true;
        html += this.getEllipsis();
      } else if (
        !lastEllipsis &&
        page < pageCount &&
        page > currentPage + currentPageOffset
      ) {
        lastEllipsis = true;
        html += this.getEllipsis();
      }
    }

    html += this.getForwardArrow(currentPage, pageCount);

    return html;
  };

  handleButtonClick = (event, element) => {
    const pageButton = element;
    const { pageNumber } = pageButton.dataset;
    const { categoryPageCount, categoryDisplayPerPage } = this.options;

    if (pageNumber !== "") {
      this.changeCategoryPage(Number(pageNumber));
      this.rebuildPaging(
        Number(pageNumber),
        categoryPageCount,
        categoryDisplayPerPage,
      );
    }
  };
}
